const colors = {
  // Base colors
  white: '#FFFFFF',

  // Brand colors - Purple/Magenta
  brand50: '#F9BFFF',
  brand75: '#D786DF',
  brand100: '#B64CC0',
  brand200: '#9F26AB',
  brand300: '#890096',
  brand400: '#6E0078',
  brand500: '#37003C',

  // Neutral colors
  neutral0: '#FFFFFF',
  neutral10: '#FBFBFB',
  neutral20: '#F7F7F7',
  neutral30: '#EEEEF0',
  neutral40: '#E4E4E6',
  neutral50: '#CBCCCF',
  neutral60: '#BFBEC4',
  neutral70: '#B4B4BA',
  neutral80: '#A8A7AF',
  neutral90: '#9C9BA3',
  neutral100: '#8F8E98',
  neutral200: '#83828C',
  neutral300: '#767581',
  neutral400: '#6C6B77',
  neutral500: '#605E6C',
  neutral600: '#555462',
  neutral700: '#474555',
  neutral800: '#3A384A',
  neutral900: '#302E40',

  // Neutral with opacity
  neutral015: 'rgba(255, 255, 255, 0.15)',
  neutral06: 'rgba(255, 255, 255, 0.06)',
  neutral03: 'rgba(255, 255, 255, 0.03)',
  neutral060: 'rgba(255, 255, 255, 0.6)',

  // Red colors
  red50: '#FEF1E6',
  red75: '#F9B4A5',
  red100: '#F6957F',
  red200: '#F36848',
  red300: '#F04923',
  red3004: 'rgba(240, 73, 35, 0.04)',
  red400: '#A83319',
  red500: '#922D15',

  // Green colors
  green300: '#17A975',
  green3006: 'rgba(23, 169, 117, 0.06)',

  // Background
  pageBg: '#060912',
  bgDark: '#14141A',

  // UI colors
  primary: '#890096',
  secondary: '#259B91',
  error: '#F04923',
  success: '#17A975',

  // Legacy/Compatible (for backward compatibility)
  blue200: '#2B3A7E',
  blue75: '#969EBF',
  green200: '#4CC3C1',

  modal: '#060912',
  ellipseOrange: '#F04923',
  ellipseBlue: '#890096', // Updated to brand purple
};

export { colors };
